module.exports = __webpack_public_path__ + "static/img/bmcgimg.575f7b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bmcgimg.png
// module id = pIMn
// module chunks = 1